// extracted by mini-css-extract-plugin
module.exports = {"chartBarExample":"index_chartBarExample_2Rjrr","chartPieExample":"index_chartPieExample_EEHbm"};